import { Component, OnDestroy, OnInit } from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

import { Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";
import { TranslationService } from "../../../_services/translation.service";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { GeneralRowEvent } from "../../../_models/general-row-event";

import { PopoverService } from "../../../_services/popover.service";
import { GenericModalComponent } from "../../../form/generic-app-modal/generic-modal.component";
import { ParentEventSearchState } from "../../../_services/eventsServices/events.service";
import {
  DepositData,
  PaperPaymentItemBatch,
} from "../receipt-page-models/PaperPaymentItem";
import { receiptMockData } from "../receipt-util-mock/receipt-mock-data";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { ReceiptPageSubmitReceiptModalContainerComponent } from "../receipt-page-submit-receipt-modal-container/receipt-page-submit-receipt-modal-container.component";
import { ReceiptManagementService } from "../../../_services/receipt-management.service";

@Component({
  selector: "receipt-page-component",
  templateUrl: "./receipt-page.component.html",
  styleUrls: [
    "./receipt-page.component.scss",
    "../../events-screen/parent-events-page/parent-events-page.component.scss",
  ],
  animations: [
    trigger("openClose", [
      state(
        "open",
        style({
          maxHeight: "400px",
          opacity: 1,
          overflow: "visible",
        })
      ),
      state(
        "closed",
        style({
          maxHeight: "1px",
          height: "1px",
          opacity: 0,
          overflow: "hidden",
        })
      ),
      transition("open => closed", [animate("0.2s")]),
      transition("* => open", [animate("0.2s")]),
      transition("closed => open", [animate("0.2s")]),
    ]),
  ],
})
export class ReceiptPageComponent implements OnInit, OnDestroy {
  public selectedBatchId: number | null = null;
  public translations$: Observable<ITranslations>;
  public searchIsOpen: boolean = true;

  public readonly $paperPaymentsBatch: BehaviorSubject<
    PaperPaymentItemBatch[]
  > = new BehaviorSubject<PaperPaymentItemBatch[]>(
    this.isDevelopmentMode ? receiptMockData.main : []
  );

  public readonly $paymentItemsSearchState: BehaviorSubject<ParentEventSearchState> =
    new BehaviorSubject<ParentEventSearchState>({
      next: null,
      previous: null,
      isLoading: false,
      count: 0,
    });

  public readonly $paymentReceiptSearchAbstract: BehaviorSubject<{
    numberOfResults: number;
    numberOfReceiptsIIssued: number;
    numberOfReceiptsOverdue: number;
    totalSum: string;
  } | null> = new BehaviorSubject<{
    numberOfResults: number;
    numberOfReceiptsOverdue: number;
    numberOfReceiptsIIssued: number;
    totalSum: string;
  } | null>(null);

  public readonly $openDeleteModal: BehaviorSubject<DepositData | false> =
    new BehaviorSubject<DepositData | false>(false);
  public scrollCallback: ($event: any) => void;

  constructor(
    protected receiptManagementService: ReceiptManagementService,
    protected modalService: NgbModal,
    protected router: Router,
    protected dataService: DataService,
    protected authenticationService: AuthenticationService,
    protected translationService: TranslationService,
    protected popoverService: PopoverService,
    protected sessionManagerService: SessionManagerService
  ) {
    this.getReceipts();
    this.translations$ = this.translationService.translations;
    this.scrollCallback = this.scrollCallbackHandler.bind(this);
  }

  public get isDevelopmentMode() {
    return this.sessionManagerService.isDevModeActive();
  }

  public ngOnInit(): void {
    this.receiptManagementService.searchReceipts({} as any).then((r) => {
      if (this.sessionManagerService.isDevModeActive()) {
        // this.openDepositReceiptModal({
        //   depositActionType: "depositBatch",
        //   batchId: 200,
        //   paymentItemId: null,
        // });
      }
    });
    this.receiptManagementService
      .getOpenReceiptsSearchResultsAbstract()
      .subscribe((results) => {
        this.$paymentReceiptSearchAbstract.next(results);
      });
  }

  public ngOnDestroy(): void {}
  public async rowEventHandler(
    $event: GeneralRowEvent<{
      batchId: number;
      paymentItemId: number;
    }>
  ) {
    const batchId = $event.eventObject.batchId;

    switch ($event.action as any) {
      case "open":
        this.selectedBatchId = batchId;
        break;
      case "close":
        this.selectedBatchId = null;
        break;
      case "delete":
        this.openDeleteReceiptModal($event.eventObject);
        break;
      case "edit":
      case "deposit":
        this.openDepositReceiptModal($event.eventObject as any);
        break;
      case "viewReceipt":
        this.viewReceipt($event.eventObject);

        break;
    }
  }

  public openDeleteReceiptModal(depositData: {
    batchId: number;
    paymentItemId: number;
  }) {
    const depositObject = this.rowEventToReceiptObject(depositData);
    this.$openDeleteModal.next(depositObject);
  }

  public openDepositReceiptModal(depositData: {
    batchId: number;
    paymentItemId: number;
    depositActionType: "depositBatch" | "editDeposit";
  }) {
    const depositObject = this.rowEventToReceiptObject(depositData);

    const modalRef: NgbModalRef = this.modalService.open(
      ReceiptPageSubmitReceiptModalContainerComponent,
      ReceiptPageSubmitReceiptModalContainerComponent.modalOptions
    );
    (
      modalRef.componentInstance as ReceiptPageSubmitReceiptModalContainerComponent
    ).modalDepositDataInput = {
      paymentBatch: depositObject.paymentBatch,
      specificPaymentItemId: depositObject.specificPaymentItemId,
    };
  }

  public deleteModalResultHandler($event: any) {
    this.deleteReceiptSuccessNotification($event).then();
  }

  public scrollCallbackHandler($event: any) {
    this.receiptManagementService.scrolledToBottomOfResults().then();
  }

  public handleSearchSectionEvent($event: GeneralRowEvent<any>) {
    this.openDepositReceiptModal($event.eventObject);
  }

  protected modalNotification(message: string) {
    let modalText = message.toString();

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "הפקדות",
      modalText,
      onlyApprove: true,
    };
    modalRef.result.then((res) => {});
  }

  private viewReceipt(depositData: { batchId: number; paymentItemId: number }) {
    const depositObject = this.rowEventToReceiptObject(depositData);
    let specificItem = depositObject.paymentBatch.paymentsItems.find(
      (pi) => pi.id === depositData.paymentItemId
    );
    if (!specificItem) {
      specificItem = depositObject.paymentBatch.paymentsItems[0];
    }

    if (!specificItem || !specificItem.receiptUrl) {
      const paymentItem = specificItem ? ` מספר ${specificItem.id}` : null;

      this.modalNotification(
        ` שגיאה - לא נמצאה קבלה לפריט   ${paymentItem || ""} `
      );
      return;
    }

    window.open(specificItem.receiptUrl, "_blank");
  }

  private rowEventToReceiptObject({
    batchId,
    paymentItemId,
  }: {
    batchId: number;
    paymentItemId: number;
  }): DepositData {
    const allBatches = this.$paperPaymentsBatch.value;
    const paymentBatch = allBatches.find((b) => b.id === batchId);

    return {
      paymentBatch,
      specificPaymentItemId: paymentItemId,
    };
  }

  private getReceipts(): void {
    if (this.isDevelopmentMode) {
      return;
    }
    this.receiptManagementService
      .getOpenReceiptsInTable()
      .subscribe((receipts: PaperPaymentItemBatch[]) => {
        this.$paperPaymentsBatch.next(receipts);
      });

    this.receiptManagementService
      .getOpenReceiptsTableSearchState()
      .subscribe((searchState) => {
        this.$paymentItemsSearchState.next(searchState);
      });
  }

  private async deleteReceiptSuccessNotification(eventObject: DepositData) {
    if (!eventObject || !eventObject.paymentBatch) {
      return;
    }

    const specificPaymentItem = eventObject.paymentBatch.paymentsItems.find(
      (pi) => pi.id === eventObject.specificPaymentItemId
    );

    if (!specificPaymentItem) {
      this.modalNotification("שגיאה - לא נמצא פריט תשלום");
      return;
    }

    const result = await this.receiptManagementService.cancelReceipt(
      specificPaymentItem.id
    );

    if (result.success) {
      const modalRef: NgbModalRef = this.modalService.open(
        GenericModalComponent
      );
      modalRef.componentInstance.modalOptions = {
        approveOption: "אישור",
        cancelOption: "",
        modalHeader: "ביטול קבלה",
        modalText: `הקבלה עבור ${specificPaymentItem.childName || ""} - ${
          specificPaymentItem.eventName
        } בוטלה בהצלחה`,
        onlyApprove: true,
      };
      modalRef.result.then((res) => {});
    } else if (result.success === false) {
      let errorBody = result.error && result.error._body;
      if (result.error instanceof Response) {
        errorBody = await result.error.text();
      }

      const errorMessage = errorBody || "אירעה שגיאה לא צפויה";
      this.modalNotification(`שגיאה בביטול הקבלה:  ${errorMessage}`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-page/receipt-page.component.ts